import moment from 'moment';

import { ExamSchedulingStatusEnum } from '@/models/ScheduledLessonExam';
import { StudentExamRecord } from '@/utils/student-exam/studentExamRecordTypes';

export const isStartedScheduledExam = ({
  status,
  datetime,
}: StudentExamRecord) =>
  status === ExamSchedulingStatusEnum.SCHEDULED &&
  moment(datetime).isSameOrBefore(moment());
